class CustomSelect extends HTMLElement {
  constructor() {
    super()
    this.bodyOverlay = document.querySelector('body')
    this.removeOverlay = document.querySelector('.plp-filter')
    this.filterDrawer = document.querySelector('.filter-drawer')
    this.select = this.querySelector('.select__select')
    this.placeholder = this.querySelector('.select-selected')
    this.optionsWrapper = this.querySelector('.select-items')
    this.options = this.querySelectorAll('.select-items div')
    this.buttonWrapper = document.querySelector('.button_wrapper')
    this.inquireToggle = document.querySelector('[data-component="inquire-toggle"]')
    this.sizeInquirySizeVariantField = document.querySelector('.variant-size')
    this.sizeInquirySizeVariant = document.querySelector('#sizeInquiryVariantSize')

    this.addEventListener('click', this.toggleVisibility.bind(this))
    if (this.removeOverlay !== null) {
      this.removeOverlay.addEventListener('click', this.removeVisibility.bind(this))
    }
    if (this.filterDrawer !== null) {
      this.filterDrawer.addEventListener('click', this.removeVisibility.bind(this))
    }
    this.init()

    if (this.inquireToggle) {
      this.inquireToggle.addEventListener('click', e => {
        this.sizeInquirySizeVariantField.style.display = 'flex'
      })
    }

  }

  init() {
    this.options.forEach((div) => {
      div.addEventListener('click', () => {
        this.setValue(div)
      })
    })
  }

  toggleVisibility() {
    this.optionsWrapper.classList.toggle('select-hide')
    this.placeholder.classList.toggle('select-arrow-active')
    this.bodyOverlay.classList.toggle('overlay-open')
  }

  removeVisibility() {
    this.optionsWrapper.classList.add('select-hide')
    this.placeholder.classList.remove('select-arrow-active')
    this.bodyOverlay.classList.remove('overlay-open')
  }

  setValue(div) {
    const { textContent } = div

    this.options.forEach((allOption) => {
      allOption.classList.remove('same-as-selected')
    })

    div.classList.add('same-as-selected')
    this.select.value = div.getAttribute('data-value')
    this.select.title = div.getAttribute('data-variant-title')
    if (this.querySelectorAll('.left-filter .select-items div').length > 0 ){
      if(window.innerWidth > 767) {
        this.placeholder.textContent = textContent
      }
    } else {
      if (div.classList.contains('pre-order')) {
        this.placeholder.classList.remove('inquire-available-selected')
        this.placeholder.classList.add('pre-order-selected')
        this.buttonWrapper.classList.remove('show-default-button')
        this.buttonWrapper.classList.remove('show-inquire-available')
        this.buttonWrapper.classList.add('show-pre-order')
        this.placeholder.textContent = 'Size: ' + textContent
      } else if (div.classList.contains('inquire-available')) {
        this.placeholder.classList.remove('pre-order-selected')
        this.placeholder.classList.add('inquire-available-selected')
        this.sizeInquirySizeVariant.value = this.select.title
        this.sizeInquirySizeVariantField.style.display = 'flex'
        this.buttonWrapper.classList.remove('show-default-button')
        this.buttonWrapper.classList.remove('show-pre-order')
        this.buttonWrapper.classList.add('show-inquire-available')
        this.placeholder.textContent = 'Size: ' + textContent
      } else {
        this.placeholder.classList.remove('pre-order-selected')
        this.placeholder.classList.remove('inquire-available-selected')
        this.buttonWrapper.classList.remove('show-pre-order')
        this.buttonWrapper.classList.remove('show-inquire-available')
        this.buttonWrapper.classList.add('show-default-button')
        this.placeholder.textContent = 'Size: ' + textContent
      }
    }

    this.classList.remove('error')
  }
}

customElements.define("custom-select", CustomSelect)
